module.exports = __webpack_public_path__ + "static/mastering-bitcoin-9418f21b568b55fdfb204b129fd45546.jpg";